<!-- 解决方案 -->
<template>
  <div class="solution-container">
    <div class="solution-wrapper">
      <header class="solution-header">
        <h2 class="solution-title" v-scroll-animate="{ animation: 'fadeInUp' }">
          狄诺尼为您提供基础设施全生命周期IT产品与解决方案
        </h2>
        <p
          class="solution-subTitle"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 200 }"
        >
          　　江苏狄诺尼作为中国基础设施数字化的知名品牌，拥有数字化设计软件产品线、智能建造产品线与基础设施运维数字孪生解决方案三个产品线。<br />
          　　设计产品线主要有：AIRoad(道路工程快速方案设计系统)、EICAD(集成交互式道路与立交设计系统)、VRRoad（道路驾驶模拟与安全评价系统）、Report
          3D（三维汇报演示系统）、Delivery 3D（设计成果管理系统），等等。<br />
          　　建造产品线包含：数字建设管理平台、智慧工地平台、智慧梁厂平台，等等。
        </p>
      </header>
      <ul class="product-lines" v-scroll-animate="{ animation: 'fadeInUp' }">
        <li
          v-for="(line, index) in productLines"
          :key="index"
          class="product-card"
          :class="{ selected: index === selectedIndex }"
          @click="openUrl(line.link)"
          @mouseenter="pauseCarousel(index)"
          @mouseleave="startCarousel"
        >
          <img :src="line.image" alt="" class="card-img" />
          <span
            class="card-background"
            :style="{ backgroundImage: 'url(' + line.imageMask + ')' }"
          ></span>
          <div class="card-content">
            <h3 class="title">{{ line.title }}</h3>
            <p class="products" v-if="line.products.length > 0">
              {{ line.products.join("  |  ") }}
            </p>
            <template v-if="line.subTitles.length > 0">
              <p
                class="products"
                v-for="(item, index) in line.subTitles"
                :key="index"
              >
                {{ item }}
              </p>
            </template>
          </div>
          <button class="know-more-btn">了解更多 ></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {
      selectedIndex: 0,
      intervalId: null,
      productLines: [
        {
          title: "数字化设计软件产品线",
          products: ["AIRoad", "EICAD", "VRRoad", "Report3D"],
          subTitles: [],
          image: require("@/assets/images/homeImg/solution_dig.png"),
          imageMask: require("@/assets/images/homeImg/solution_dig_bg.png"),
          link: "/digital",
        },
        {
          title: "智能建造产品线",
          products: [
            "数字建设管理平台",
            "数字智慧工地平台",
            "数字智能梁厂平台",
          ],
          subTitles: [],
          image: require("@/assets/images/homeImg/solution_intel.png"),
          imageMask: require("@/assets/images/homeImg/solution_intel_bg.png"),
          link: "/intelligent",
        },
        {
          title: "基础设施运维数字孪生解决方案",
          products: [
            "航道基础平台",
            "数字孪生公路基础平台",
            "数字孪生城市基础平台",
          ],
          subTitles: [],
          image: require("@/assets/images/homeImg/solution_mainten.png"),
          imageMask: require("@/assets/images/homeImg/solution_mainten_bg.png"),
          link: "/dtwin",
        },
      ],
    };
  },
  computed: {},
  created() {
    this.startCarousel();
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.intervalId);
    this.content01.intervalId = null;
  },
  methods: {
    openUrl(link) {
      this.$uniFun.openInCurrentTab(`${link}`);
    },
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.selectedIndex =
          (this.selectedIndex + 1) % this.productLines.length;
      }, 3000);
    },
    pauseCarousel(index) {
      clearInterval(this.intervalId);
      this.selectedIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
.solution-container {
  padding: 80px 0;
  background: #f4f6f8;
  .solution-wrapper {
    width: 1200px;
    margin: 0 auto;
  }
}

.solution-header {
  text-align: center;
  margin-bottom: 40px;
  .solution-title {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
    color: #333;
  }
  .solution-subTitle {
    font-size: 16px;
    line-height: 32px;
    color: #333;
    text-align: justify;
  }
}

.product-lines {
  display: flex;
  justify-content: space-between;
  gap: 20px; /* 卡片之间的间距 */
  height: 320px;
}

.product-card {
  position: relative;
  flex: 1; /* 每个卡片占据可用空间的三分之一 */
  min-width: 0; /* 防止flex item溢出 */
  height: 320px; /* 根据设计调整卡片高度 */
  border-radius: 8px;
  overflow: hidden; /* 确保放大的背景图不会超出卡片边界 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: flex 0.5s ease, box-shadow 0.3s ease; /* 为卡片本身添加轻微浮动效果 */

  // &:hover {
  //   transform: translateY(-5px);
  //   box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  //   .card-background {
  //     transform: scale(1.1); /* 鼠标悬停时背景图片放大 */
  //   }
  // }
  .card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .card-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    transition: transform 0.4s ease-out; /* 图片放大动画效果 */
    z-index: 10;
  }
  .card-content {
    position: absolute;
    top: 54px;
    left: 40px;
    z-index: 20;
    color: #fff;
    .title {
      margin-bottom: 12px;
      line-height: 32px;
      font-size: 20px;
      transition: all 0.5s ease;
    }

    .products {
      font-size: 16px;
      line-height: 32px;
      text-align: justify;
      opacity: 0;
      transition: all 0.25s ease;
    }
  }
  .know-more-btn {
    position: absolute;
    left: 40px;
    bottom: 50px;
    padding: 8px 24px;
    background-color: transparent;
    color: white;
    border: 1px solid white;
    border-radius: 20px;
    cursor: pointer;
    font-size: 13px;
    align-self: flex-start; /* 按钮靠左 */
    transition: background-color 0.3s ease, color 0.3s ease;
    z-index: 20;
    &:hover {
      background-color: white;
      color: #007bff; /* 或者卡片的主题色 */
    }
  }
  &.selected {
    flex: 1.8;
    .card-content {
      .products {
        opacity: 1;
      }
      .title {
        font-size: 24px;
      }
    }
  }
}
</style>
